import React from 'react'
import ModalWrapper from '../ModalWrapper'
import AddPasswordContainer from '../../../containers/modals/account/AddPasswordContainer'

const AddPasswordModal= props => {

	return (
		 <div className="addPassword-modal">
			<ModalWrapper
				{...props}
				title="Add Email and Password Sign-in" 
				modalStyle="dark"
				closeBtn={false}
			>

				<AddPasswordContainer {...props} />
			 
			</ModalWrapper>

		</div>

	)
}

export default AddPasswordModal


// WEBPACK FOOTER //
// ./src/components/modals/account/AddPasswordModal.js